import { DatePicker } from "antd";
import moment from "moment";
import CalendarIcon from "../../../assets/images/calendar.png";

export default function CrrDatePicker(props) {
  const {
    selectField,
    placeholderText,
    onChange,
    defaultValue,
    setValue,
    expand,
  } = props;

  const handleOnChange = (date, dateString) => {
    setValue(dateString);
    onChange && onChange(dateString);
  };

  return (
    <DatePicker
      style={{ width: expand ? "100%" : "auto" }}
      bordered={false}
      format="MM/DD/YYYY"
      onChange={handleOnChange}
      defaultValue={
        defaultValue && moment(defaultValue.replace("-", "/"), "MM/DD/YYYY")
      }
      placeholder={!selectField && placeholderText}
      suffixIcon={<img src={CalendarIcon} className="calendar-icon" />}
    />
  );
}
